module.exports = __webpack_public_path__ + "img/banner-circle.756ab3b6.png";